import { render } from "./MediaModal.vue?vue&type=template&id=95e79ea4&scoped=true"
import script from "./MediaModal.vue?vue&type=script&lang=js"
export * from "./MediaModal.vue?vue&type=script&lang=js"

import "./MediaModal.vue?vue&type=style&index=0&id=95e79ea4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95e79ea4"]])

export default __exports__